import {
  LocalStorageNamespace,
  createLocalStorageContextProvider,
} from "@utils";

type TLocalStorageAdminKeys = "surveyResultsTextSize";

const CAdminNamespace = new LocalStorageNamespace<TLocalStorageAdminKeys>(
  "admin",
);

const AdminLocalStorage = {
  /**
   * - tracks the text size preference for survey results display in admin view
   * - stored as a number representing rem units (1.0rem = 10px baseline)
   */
  surveyResultsTextSize: CAdminNamespace.createKeyHandler(
    "surveyResultsTextSize",
    1.0,
  ),
} as const;

/**
 *
 * @deprecated use `useAdminLocalStorageContext` instead
 */
export default function useAdminLocalStorage() {
  return AdminLocalStorage;
}

export const {
  Provider: AdminLocalStorageContextProvider,
  useStorage: useAdminLocalStorageContext,
} = createLocalStorageContextProvider(AdminLocalStorage);
